import { useDevice } from "../../../common/hooks/useDevice";
import MobileAuthContentWrapper from "./MobileAuthContentWrapper";
import WebAuthContentWrapper from "./WebAuthContentWrapper";

function AuthContentWrapper({
    children,
    contentPadding,
    overflowY,
    overflowX,
    contentMaxHeight,
    header,
    footer,
    contentMinHeight,
}) {
    const currentDevice = useDevice();

    if (currentDevice === "mobile" || currentDevice === "tablet") {
        return (
            <MobileAuthContentWrapper
                contentPadding={contentPadding}
                overflowY={overflowY}
                overflowX={overflowX}
                contentMaxHeight={contentMaxHeight}
                contentMinHeight={contentMinHeight}
                header={header}
                footer={footer}
            >
                {children}
            </MobileAuthContentWrapper>
        );
    }
    return (
        <WebAuthContentWrapper
            contentPadding={contentPadding}
            overflowY={overflowY}
            overflowX={overflowX}
            contentMaxHeight={contentMaxHeight}
            contentMinHeight={contentMinHeight}
            header={header}
            footer={footer}
        >
            {children}
        </WebAuthContentWrapper>
    );
}

export default AuthContentWrapper;
